import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';

import { NotificationService } from '../../shared/services/notification.service';
import { SupplierService } from '../../pages/suppliers/supplier.service';
import * as suppliersActions from '../actions/suppliers.actions';
import { ResponseData } from '../../utils/response';
import { Supplier } from '../../pages/suppliers/supplier';
import { PremiitError } from '../../utils/premiit-error';
import { of } from 'rxjs';

@Injectable()
export class SuppliersEffects {
  constructor(private action$: Actions, private supplierService: SupplierService,
    private notify: NotificationService,
    private router: Router
  ) {}

  public getSuppliersEffect = createEffect(
    () => this.action$.pipe(
      ofType(suppliersActions.getSuppliersAction),
      mergeMap(() => {
        return this.supplierService.findProviders()
          .pipe(
            map((response: ResponseData<Supplier[]>) => {
              const suppliers: Supplier[] = response.data;
              return suppliersActions.getSupplierSuccessAction({ suppliers });
            }),
            catchError((error: PremiitError) => {
              return of(suppliersActions.getSupplierErrorAction({ error }));
            })
          );
      })
    )
  );

  public createSupplierEffect = createEffect(
    () => this.action$.pipe(
      ofType(suppliersActions.createSupplierAction),
      mergeMap((action) => {
        return this.supplierService.createSupplier(action.supplier)
          .pipe(
            map((response: ResponseData<Supplier>) => {
              const supplier: Supplier = response.data;
              return suppliersActions.createSupplierSuccessAction({ supplier });
            }),
            tap(() => {
              this.notify.success('Proveedor registrado con éxito');
              this.router.navigate(['suppliers']);
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(suppliersActions.createSupplierErrorAction({ error }));
            })
          );
      })
    )
  );

  public updateSupplierEffect = createEffect(
    () => this.action$.pipe(
      ofType(suppliersActions.updateSupplierAction),
      mergeMap((action) => {
        return this.supplierService.updateSupplier(action.supplier)
          .pipe(
            map((response: ResponseData<Supplier>) => {
              const supplier: Supplier = response.data;
              this.notify.success('El proveedor se actualizo éxito');
              this.router.navigate(['suppliers']);
              return suppliersActions.updateSupplierSuccessAction({ supplier });
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(suppliersActions.updateSupplierErrorAction({ error }));
            })
          );
      })
    )
  );
}